import React from 'react';
import cn from 'classnames';
import findIndex from 'lodash/findIndex';

import RsSlidable from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidable';

function StepsList({ steps, activeStep, setActiveStep, resized, onActiveStepChange }) {
  const activeStepIndex = findIndex(steps, { step: activeStep });

  return (
    <RsSlidable
      className="project-route-conditions-steps-list rx-flex-1"
      contentClassName="project-route-conditions-steps-list__list"
      itemClassName={({ step }) => cn('project-route-conditions-steps-list__step', { current: step === activeStep })}
      items={steps}
      renderItem={({ step }) => (
        <span
          role="button"
          style={{ cursor: 'pointer' }}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onActiveStepChange(step);
              setActiveStep(step);
            }
          }}
          onClick={() => {
            onActiveStepChange(step);
            setActiveStep(step);
          }}>
          Step {step}
        </span>
      )}
      visibleItemIndex={activeStepIndex}
      resized={resized}
    />
  );
}

export default StepsList;
